import styled from "styled-components";

import WebApi from "api/ApiConstants";
// import OaAlert from "components/Alerts/OaAlert";
import { useEffect, useState } from "react";
// import CustomLoader from "components/CustomLoader";
import React from "react";
import FlightMarkupForm from "./FlightMarkupForm";

const FlightMarkupNew = (props) => {
  const [errorText, setErrorText] = useState("");
  const [markupList, setMarkupList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isLoading) {
      WebApi.getFlightMarkupList(
        {},
        (response) => {
          setMarkupList(response.data);
          setIsLoading(false);
          setIsError(!response.success);
          setErrorText(response.message);
        },
        (error) => console.error("Error", error)
      );
    }
  }, [isLoading]);

  return (
    <RootContainer>
      <div className="page-container">
        <div className="card base-card">
          <div className="header-section">
            <h3>FLIGHT MARKUP</h3>
          </div>
          <div className="form-section">
            {markupList && !isLoading ? (
              <FlightMarkupForm markupList={markupList} />
            ) : (
              <div style={{ textAlign: "center" }}>Loading...</div>
            )}
          </div>
        </div>
      </div>
      {/* <OaAlert infoText={errorText} isError={isError} setIsError={setIsError} /> */}
    </RootContainer>
  );
};

export default FlightMarkupNew;

const RootContainer = styled.div`
  padding: 5px 30px;

  .page-container {
    box-sizing: border-box;
    background-color: #cccccc;
  }

  .base-card {
    padding: 20px 20px 20px;
    position: relative;
  }

  .header-section {
    border-radius: 4px;
    position: absolute;
    left: 20px;
    right: 20px;
    top: -2px;
    height: 25px;
    padding: 5px 0;
    background-color: #444;
    color: #fff;

    h3 {
      font-size: 1.17em;
      margin-block-start: 0;
      margin-block-end: 0;
      font-weight: 500;
      width: fit-content;
      padding: 0 30px;

      text-transform: uppercase;
    }
  }

  .form-section {
    box-sizing: border-box;
    padding: 30px 10px 10px;
    background-color: #fff;
  }

  .form-section-card {
    padding: 40px;
  }
`;
